export interface ISAVINGS_FORMULA {
  loanAmount: number | undefined;
  rateOfInterest: number | undefined;
  loanTenure: number | undefined;
}

export const SAVINGS_FORMULA = ({
  loanAmount,
  rateOfInterest,
  loanTenure,
}: ISAVINGS_FORMULA) => {
  if (
    !loanAmount ||
    !rateOfInterest ||
    !loanTenure ||
    Number(loanAmount) < 0 ||
    Number(rateOfInterest) < 0 ||
    Number(loanTenure) < 0
  ) {
    return {
      monthlyEmi: 0,
      totalAmountPayable: 0,
      interestComponent: 0,
    };
  }

  const monthlyInterestRate = Number(rateOfInterest) / (12 * 100);

  const totalPayments = Number(loanTenure) * 12;

  const interestTimesPrincipal =
    Number(loanAmount) *
    monthlyInterestRate *
    Math.pow(1 + monthlyInterestRate, totalPayments);

  const compoundFactor = Math.pow(1 + monthlyInterestRate, totalPayments) - 1;

  const monthlyEmi = Number(
    (interestTimesPrincipal / compoundFactor).toFixed(0)
  );

  const totalAmountPayable = monthlyEmi * totalPayments;

  const interestComponent = totalAmountPayable - Number(loanAmount);

  return {
    monthlyEmi: monthlyEmi.toFixed(0),
    totalAmountPayable: totalAmountPayable.toFixed(0),
    interestComponent: interestComponent.toFixed(0),
  };
};
